module.exports = __webpack_public_path__ + "static/img/4bg_8.13fa2c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_8.png
// module id = 719
// module chunks = 1